var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"error-modal","title":_vm.title},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ok}){return [_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return ok()}}},[_vm._v("OK")])]}}])},[_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }